import { defineStore } from "pinia";

import {
  getDatabase,
  ref,
  set,
  push,
  child,
  update,
  onValue,
  increment,
} from "firebase/database";

import mixpanel from "mixpanel-browser";

const db = getDatabase();

export const useUploadStore = defineStore("upload", {
  state: () => ({ upload: null }),
  actions: {
    async getDataFromDB(userId, path) {
      return new Promise(function (resolve) {
        onValue(
          ref(db, path),
          (snapshot) => {
            resolve(snapshot.val());
          },
          {
            onlyOnce: false,
          }
        );
      });
    },

    async writeDataToDB(userId, data, path) {
      const postData = {};

      for (const key in data) {
        if (key !== "writeType") {
          postData[key] = data[key];
        }
      }

      let updates = {};

      if (data["writeType"] == "stats") {
        const postDataIncrements = {};
        for (const key in postData) {
          postDataIncrements[key] = increment(postData[key]);
        }
        update(ref(db, path), postDataIncrements);
      }
      if (data["writeType"] == "quota") {
        update(ref(db, path), {
          totalUploadCount: increment(1),
          weeklyUploadCount: increment(1),
          dailyUploadCount: increment(1),
        });
      }
      if (data["writeType"] == "submission") {
        mixpanel.track("submission", postData);

        const newPostKey = push(child(ref(db), path)).key;

        updates[path + "/" + newPostKey] = postData;
        update(ref(db), updates);
      }
      if ("writeType" in data == false) {
        update(ref(db, path), postData);
      }

      return;
    },

    async createUploadRequest(
      userId,
      filename,
      fileType,
      fileSize,
      videoName,
      fileExtension,
      language
    ) {
      const date = Date.now();

      const newPostKey = push(child(ref(db), "uploadRequest/" + userId)).key;

      const postData = {
        uid: userId,
        filename: newPostKey + fileExtension,
        fileType: fileType,
        fileSize: fileSize,
        created: date,
        language: language,
      };

      const updates = {};
      updates["uploadRequest/" + userId + "/" + newPostKey] = postData;

      update(ref(db), updates);

      set(ref(db, "videos/" + newPostKey), {
        userId: userId,
        videoId: newPostKey,
        originalName: videoName + fileExtension,
        filename: newPostKey + fileExtension,
        created: date,
      });
      mixpanel.track("Video uploaded", {
        fileType: fileType,
        fileSize: fileSize,
        fileExtension: fileExtension,
        landingSource: (() => {
          try {
            return sessionStorage.getItem("landingSource") || "direct";
          } catch (e) {
            return "unknown";
          }
        })(),
      });
      mixpanel.people.increment("Videos uploaded");

      return newPostKey;
    },

    async getSignedWriteUrl(userId, uploadRequestKey) {
      let writeUrl = null;

      return new Promise(function (resolve) {
        onValue(
          ref(
            db,
            "/uploadRequest/" + userId + "/" + uploadRequestKey + "/writeUrl"
          ),
          (snapshot) => {
            const data = snapshot.val();
            writeUrl = data;
            if (writeUrl != null) {
              resolve(writeUrl);
            }
          },
          {
            onlyOnce: false,
          }
        );
      });
    },

    async getDownloadUrl(userId, uploadRequestKey) {
      let downloadUrl = null;

      return new Promise(function (resolve) {
        onValue(
          ref(
            db,
            "/uploadRequest/" + userId + "/" + uploadRequestKey + "/downloadUrl"
          ),
          (snapshot) => {
            const data = snapshot.val();
            downloadUrl = data;
            if (downloadUrl != null) {
              resolve(downloadUrl);
            }
          },
          {
            onlyOnce: false,
          }
        );
        setTimeout(timeoutFunction, 420000);
        function timeoutFunction() {
          resolve("error");
        }
      });
    },

    async getCourseWordCount(userId, uploadRequestKey, type) {
      let courseWords = null;

      return new Promise(function (resolve) {
        onValue(
          ref(
            db,
            "/uploadRequest/" +
              userId +
              "/" +
              uploadRequestKey +
              "/amountCourseWords"
          ),
          (snapshot) => {
            const data = snapshot.val();
            courseWords = data;
            if (courseWords != null) {
              mixpanel.track("Course word", {
                displayedForUser: true,
              });
              mixpanel.people.increment("Course words found", courseWords);
              resolve(courseWords);
            }
          },
          {
            onlyOnce: false,
          }
        );
        setTimeout(timeoutFunction, 420000);
        function timeoutFunction() {
          resolve("error");
        }
      });
    },

    async watchDataInDB(dbPath, type) {
      let dataToWatch = null;

      return new Promise(function (resolve) {
        onValue(
          ref(db, dbPath),
          (snapshot) => {
            const data = snapshot.val();
            dataToWatch = data;
            if (dataToWatch != null) {
              if (
                type === "object" &&
                dataToWatch !== null &&
                typeof dataToWatch !== "object"
              ) {
                dataToWatch = JSON.parse(dataToWatch);
                resolve(dataToWatch);
              } else {
                resolve(dataToWatch);
              }
            }
          },
          {
            onlyOnce: false,
          }
        );
        setTimeout(timeoutFunction, 420000);
        function timeoutFunction() {
          resolve("error");
        }
      });
    },

    async resetUpload() {
      this.setUpload(null);
    },

    async trackMixpanel(trackingEvent, trackingObj) {
      mixpanel.track(trackingEvent, trackingObj);
      return;
    },

    setUpload(payload) {
      this.upload = payload;
    },
  },
});
